import type { ComponentProps } from "react";
import type { WorkOsWidgets } from "@workos-inc/widgets";
import { fontFamilyUI } from "@karda/design-tokens";

type WorkOsTheme = ComponentProps<typeof WorkOsWidgets>["theme"];

/**
 * Bridges the KARDA design language into the WorkOS/Radix widgets as far as
 * their theme API allows. The Radix theme prop only accepts NAMED accent
 * colors — arbitrary brand hex is not supported — so "indigo" stands in as
 * the closest named accent to the KARDA navy; deeper alignment would need
 * the widgets' `elements` prop or CSS-variable overrides on .radix-themes.
 */
export function getWorkOsWidgetTheme(
  mode: "light" | "dark",
  options?: {
    /**
     * false stops the Radix Theme root from painting its own background
     * surface, letting the widget inherit the host panel's color — use when
     * the widget sits inside an app card and its own dark slab would butt
     * against the card/panel borders.
     */
    hasBackground?: boolean;
  },
): WorkOsTheme {
  return {
    appearance: mode,
    accentColor: "indigo",
    grayColor: "slate",
    radius: "medium",
    fontFamily: fontFamilyUI,
    ...(options?.hasBackground === false ? { hasBackground: false } : {}),
  };
}
